import { useDispatch, useSelector } from "react-redux"
import BasicModule from "../../Commons/BasicModule"
import AuthCMS from "../../Layouts/AuthCMS"
import { getListUsersRequest as getList, getListUserState as getState, updateUserByIDRequest as updateItem, getUsersDashboard as stateDashboard } from "../../Stores/UserSlice"
import { useEffect, useState } from "react"
import { CheckCircleTwoTone } from '@ant-design/icons';
import { Card, Row, Col, DatePicker, Spin } from 'antd';

// Edit
const modelField = ['email', 'full_name', 'phone_number']
const headerInfo = {
    title: "User",
    description: "List User",
}

// No Edit 
const columnTable = modelField.map((field) => ({
    title: field.toUpperCase(),
    dataIndex: field,
    key: field,
}))

const customColumn = [
    ...columnTable, 
    {
        title: 'ACTIVE',
        dataIndex: 'is_active',
        key: 'is_active',
        width: 100,
        filters: [
            {
              text: 'Active',
              value: true,
            },
            {
              text: 'Inactive',
              value: false,
            },
        ],
        onFilter: (value, record) => record.is_active == value,
        render: (record) => record ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CheckCircleTwoTone twoToneColor="#ccc" />
    },
    {
        title: 'SUPPERUSER',
        dataIndex: 'is_superuser',
        key: 'is_superuser',
        width: 100,
        filters: [
            {
              text: 'Active',
              value: true,
            },
            {
              text: 'Inactive',
              value: false,
            },
        ],
        onFilter: (value, record) => record.is_superuser == value,
        render: (record) => record ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CheckCircleTwoTone twoToneColor="#ccc" />
    },
    {
        title: 'VERIFY',
        dataIndex: 'is_verify',
        key: 'is_verify',
        width: 100,
        filters: [
            {
              text: 'Active',
              value: true,
            },
            {
              text: 'Inactive',
              value: false,
            },
        ],
        onFilter: (value, record) => value == record.is_verify,
        render: (record) => record ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CheckCircleTwoTone twoToneColor="#ccc" />
    },
]

const User = () => {
    const data = useSelector(getState)
    const {users_cash_in, users_cash_out, user_cashback} = useSelector(stateDashboard)
    const dispatch = useDispatch();
    const [dataSource, setDataSource] = useState([]);
    const [keySearch, setKeySearch] = useState("");
    const [cashLoading, setCashLoading] = useState(false);

    useEffect(() => {
        dispatch(getList())
    }, [dispatch])

    useEffect(() => {
        let newData = data.filter((e) => {
            for (const [key, value] of Object.entries(e)) {
                return value.toLowerCase().indexOf(keySearch) !== -1
            }
        })
        setDataSource(newData)
    }, [data, keySearch])

    const createNewHandle = (data) => {
        // dispatch(createNew(data)).then(res => {
        //     dispatch(getList())
        // })
    }

    const updateHandle = (data) => {
        // dispatch(updateItem(data)).then(res => {
        //     dispatch(getList())
        // })
    }

    const deleteHandle = (data) => {
        // dispatch(deleteItem(data)).then(res => {
        //     dispatch(getList())
        // })
    }

    const onChangeMonth = (date, dateString) => {
        setCashLoading(true)
        // Call API
        dispatch(getList(dateString)).then(res => {
            setCashLoading(false)
        })
    }

    return <AuthCMS tabActive={"/users"}>
        <Row gutter={[8,8]} style={{ margin: "16px 4px" }}>
            <Col span={24}>
                Month: 
                <DatePicker 
                    onChange={onChangeMonth} 
                    picker="month" 
                />
                {cashLoading ? <Spin style={{marginLeft: 8}}/> : ""}
            </Col>
            <Col span={8}>
                <Card title="Total Cash In" bordered={false}>
                    {users_cash_in}
                </Card>
            </Col>
            <Col span={8}>
                <Card title="Total Cash Out" bordered={false}>
                    {users_cash_out}
                </Card>
            </Col>
            <Col span={8}>
                <Card title="Total Cashback" bordered={false}>
                    {user_cashback}
                </Card>
            </Col>
        </Row>
        <BasicModule
            columnTable={customColumn}
            dataList={dataSource}
            modelField={modelField}
            createNewHandle={createNewHandle}
            updateHandle={updateHandle}
            deleteHandle={deleteHandle}
            setKeySearch={setKeySearch}
        />
    </AuthCMS>
}

export default User